import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const textShadow = '0 4px 24px rgba(10,45,94,0.35), 0 2px 8px rgba(10,45,94,0.25)';

  return (
    <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://storage.readdy-site.link/project_files/24d9f673-4dd5-4514-9bb2-bf7280a460c7/c7ba7d3e-2c8d-49b0-b17a-da2cdc917b37_364254.jpg?v=86aa8db74f641084bf72d4652340f461"
          alt="Penghu Ocean"
          className="w-full h-full object-cover"
          loading="eager"
          style={{ filter: 'brightness(1.2) contrast(1.05) saturate(1.05)' }}
        />
        {/* Elegant overlay: deep blue tint top-down + warm golden glow bottom-up */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A2D5E]/30 via-[#0A2D5E]/10 to-[#0A2D5E]/20" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A2D5E]/20 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#C9A86A]/15 via-transparent to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A2D5E]/10 via-transparent to-[#C9A86A]/10" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 md:px-8 w-full mx-auto pt-24 md:pt-32">
        {/* Decorative top line */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="w-12 h-px bg-[#C9A86A]/70" />
          <div className="w-2 h-2 rotate-45 border border-[#C9A86A]/70" />
          <div className="w-12 h-px bg-[#C9A86A]/70" />
        </div>

        {/* Title */}
        <h1
          className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-wide mb-2"
          style={{ textShadow }}
        >
          {t('hero.title1')}
        </h1>
        <h2
          className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-wide mb-6"
          style={{ textShadow }}
        >
          {t('hero.title2')}
        </h2>

        {/* Subtitle */}
        <p
          className="text-lg md:text-xl lg:text-2xl text-white font-medium tracking-wider mb-10"
          style={{ textShadow: '0 2px 12px rgba(10,45,94,0.3)' }}
        >
          {t('hero.subtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate('/videos')}
            className="group flex items-center gap-2 px-8 py-3 bg-[#0A2D5E] hover:bg-[#0C3A75] text-white rounded-full text-sm font-medium transition-all duration-300 shadow-lg whitespace-nowrap border border-[#0A2D5E]/20 hover:border-[#C9A86A]/60"
          >
            {t('hero.cta.videos')}
            <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform" />
          </button>
          <button
            onClick={() => navigate('/media')}
            className="group flex items-center gap-2 px-8 py-3 bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/50 hover:border-[#C9A86A]/60 text-white rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap"
            style={{ textShadow: '0 1px 4px rgba(10,45,94,0.2)' }}
          >
            {t('hero.cta.media')}
            <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-[10px] text-white/70 tracking-widest uppercase">
          Scroll
        </span>
        <div className="w-5 h-8 border border-white/50 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2 bg-white/70 rounded-full animate-bounce" />
        </div>
      </div>
    </section>
  );
}